import { render, staticRenderFns } from "./DialogFooter.vue?vue&type=template&id=c9f227e8&scoped=true&"
import script from "./DialogFooter.vue?vue&type=script&lang=js&"
export * from "./DialogFooter.vue?vue&type=script&lang=js&"
import style0 from "./DialogFooter.vue?vue&type=style&index=0&id=c9f227e8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../lib/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9f227e8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/rec-rich/lib/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c9f227e8')) {
      api.createRecord('c9f227e8', component.options)
    } else {
      api.reload('c9f227e8', component.options)
    }
    module.hot.accept("./DialogFooter.vue?vue&type=template&id=c9f227e8&scoped=true&", function () {
      api.rerender('c9f227e8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/lib/components/ui/DialogFooter.vue"
export default component.exports